import axios from 'axios';
import qs from 'qs';

const MOBILE_TESTING = true;
const NGROK_URL = 'http://2c1c063e.ngrok.io';
if (window.location.hostname === 'localhost') {
  window.APP_URL = 'http://localhost:8080';
} else if (window.location.port === '8080' && MOBILE_TESTING) {
  window.APP_URL = `${NGROK_URL}`;
} else {
  window.APP_URL = 'https://app.signable.co.uk';
}

/* eslint-disable */
String.prototype.getValueByKey = function getValueByKey(k) {
  const p = new RegExp(`\\b${k}\\b`, 'gi');
  return this.search(p) !== -1 ? decodeURIComponent(this.substr(this.search(p) + k.length + 1).substr(0, this.substr(this.search(p) + k.length + 1).search(/(&|;|$)/))) : '';
};
/* eslint-enable */

/*--------------------------------
  SEND ENVELOPE VIEWED TASK
  * Sends email to client that
  * the customers has viewed
  * the envelope
  @return Promise
---------------------------------*/
export function envelopeViewed(requestedEnvelope) {
  if (!requestedEnvelope.preview_encrypt) {
    return axios.get(`${window.APP_URL}/ajax/envelope-viewed.php`, {
      params: requestedEnvelope,
    }).then(response => response);
  }
  return null;
}

/*--------------------------------
  GET ENVELOPE
  * Get all documents, envelope
  * status, client info & config
  @return Promise
---------------------------------*/
export function getEnvelope(store) {
  const requestedEnvelope = store.getters.requestedEnvelope;
  if (requestedEnvelope.preview_encrypt) {
    return axios.get(`${window.APP_URL}/ajax/signing-page-preview.php`, {
      params: requestedEnvelope,
    }).then(data => axios.get(`${window.APP_URL}/ajax/envelope-data.php`, {
      params: {
        envelope_fingerprint: data.data.envelope_fingerprint,
        signature_fingerprint: data.data.signature_fingerprint,
      },
    }).then(response => response));
  }

  return axios.get(`${window.APP_URL}/ajax/envelope-data.php`, {
    params: requestedEnvelope,
  }).then(response => response);
}

/*--------------------------------
  REJECT ENVELOPE
  * Reject Document
  @return Promise
---------------------------------*/
export function rejectDocument({ store, reason }) {
  const request = {
    envelopeId: store.state.envelope.id,
    envelopeFingerprint: store.state.requestedEnvelope.envelope_fingerprint,
    companyId: store.state.clientInfo.company_id,
    clientId: store.state.clientInfo.client_id,
    signatureFingerprint: store.state.requestedEnvelope.signature_fingerprint,
    rejectionReason: reason,
  };
  const encodedRequest = qs.stringify(request);
  return axios.post(`${window.APP_URL}/ajax/envelope-reject.php`, encodedRequest)
    .then(response => response);
}

/*--------------------------------
  SUBMIT ENVELOPE
  * Submit document with all
  * data that has been added
  @param store - Object of fields
  @return Promise
---------------------------------*/
export function submitEnvelope({ store }) {
  const allFields = store.getters.fieldsForParty;
  const fields = [];
  allFields.forEach((field) => {
    const contractId = field.contract_id;
    const contractSentId = field.contract_sent_id;
    const inputId = field.id;
    let inputValue = field.content;
    let inputFormat = '';
    const inputFont = field.font || 'arial';
    const inputSize = field.font_size || 18;
    switch (field.type) {
      case 'signature':
        if (field.content !== null && field.content !== '') {
          inputFormat = 'typed';
          inputValue = field.content;
        } else if (field.drawn_json !== null && field.drawn_json !== '') {
          inputFormat = 'drawn';
          inputValue = JSON.stringify(field.drawn_json);
        } else if (field.upload !== null && field.upload !== '') {
          inputFormat = 'upload';
          inputValue = field.upload;
        }
        break;
      case 'checkbox':
        inputValue = field.content;
        break;
      case 'radio':
        inputValue = field.content;
        break;
      case 'upload':
        // uploaded files
        if (Array.isArray(field.upload)) {
          inputFormat = 'upload-field';
          inputValue = [];
          field.upload.forEach((upload) => {
            inputValue.push(upload.uuid);
          });
          inputValue = JSON.stringify(inputValue);
        }
        break;
      default:
        inputValue = field.content;
    }
    fields.push({
      inputId,
      contractId,
      contractSentId,
      inputValue,
      inputFormat,
      inputFont,
      inputSize,
    });
  });
  const request = {
    companyId: store.state.clientInfo.company_id,
    envelopeFingerprint: store.state.requestedEnvelope.envelope_fingerprint,
    envelopeId: store.state.envelope.id,
    clientId: store.state.clientInfo.client_id,
    signatureFingerprint: store.state.requestedEnvelope.signature_fingerprint,
    inputs: fields,
  };
  return axios.post(`${window.APP_URL}/ajax/envelope-sign.php`, JSON.stringify(request))
    .then(response => response);
}

export default {
  getEnvelope,
  submitEnvelope,
  rejectDocument,
  envelopeViewed,
};



// WEBPACK FOOTER //
// ./src/store/api.js